import React from "react";
import {
  FormAutocomplete,
  formClasses,
  labelClasses,
  LabeledAutocomplete,
} from "../styles/AutocompleteStyles";
import { handleMUISelectEvent, toStandardCase } from "../utils/UtilFunctions";
import { Keys } from "../utils/Enum.keys";
import { TextField } from "@mui/material";
import { EMPTY_STRING } from "../utils/constants";
export enum AssetStatus {
  WORKING = "WORKING",
  NOT_WORKING = "NOT_WORKING",
}

interface Props {
  value: string;
  onChange: (newValue: string) => void;
  label?: string;
  disabled?: boolean;
}
const AssetStatusSelect = ({ value, onChange, label, disabled }: Props) => {
  const options = Object.values(AssetStatus);

  const commonAutocompleteProps = {
    className: label ? labelClasses.inputRoot : formClasses.inputRoot,
    options: options,
    openOnFocus: true,
    disabled: disabled,
    onChange: (e: React.SyntheticEvent<Element, Event>, value: unknown) =>
      onChange(value as string),
  };

  const commonTextFieldProps = {
    label: label || "",
    fullWidth: true,
    InputLabelProps: { shrink: label ? true : false },
    className: label
      ? labelClasses.formControlRoot
      : formClasses.formControlRoot,
  };

  const Autocomplete = label ? LabeledAutocomplete : FormAutocomplete;

  return (
    <Autocomplete
      {...commonAutocompleteProps}
      value={value}
      // Conditional value
      isOptionEqualToValue={(option) =>
        (option as string) === value || value === EMPTY_STRING
      }
      getOptionLabel={(option) =>
        toStandardCase(option as string).replaceAll("_", " ")
      }
      onKeyDown={(e) => {
        if (e.key === Keys.ENTER) {
          handleMUISelectEvent(e);
        }
      }}
      // autoComplete={false}
      renderInput={(params) => (
        <TextField
          {...params}
          {...commonTextFieldProps}
          autoComplete="one-time-code"
        />
      )}
    />
  );
};

export default AssetStatusSelect;
